import styled, { css } from 'styled-components';
import { Typography } from '../ui/Typography';
import { FlexibleDiv } from '../../styled/common';
import { Breakpoints, FontWeight } from '../../styled/constants';
import { PageWrapper } from '../../styled/pageLayout.styles';
import { SectionHeaderContainer } from '../NewSectionHeader/styled';

export const SearchPageTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.primary};
  padding: 0 15px;
  margin-top: 0;
  text-wrap: balance;
  font-size: 18px;
  font-weight: ${FontWeight.medium};

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 0 40px;
  }

  @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding: 5px 20px 15px;
    margin-bottom: 10px;
  }
`;

export const SearchBreadcrumbsContainer = styled(PageWrapper)`
  padding-bottom: 0;
`;

export const AdsTitle = styled(Typography)`
  margin: 0;
  display: flex;
  gap: 5px;
`;

export const AdsTitleCount = styled(Typography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const SectionRightBlock = styled(FlexibleDiv)`
  justify-content: space-between;
  gap: 5px;
  width: 100%;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    gap: 10px;
  }
`;

export const sectionStylesMapView = (isMapView: boolean) => css`
  ${isMapView &&
  `
    ${SectionHeaderContainer}{
      margin-bottom: 0;

      @media (min-width: ${Breakpoints.smallDesktop}px) {
        margin-bottom: 5px;
      }
    }
  `};
`;
